Controller.$inject = [];

function Controller() {
}

export function HuiDialog() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            sizing: '@',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: () => {
            return `
                <div class="hui-dialog modal h-modal"
                     tabindex="-1">
                    <div class="dialog modal-dialog dialog-{{$huiCtrl.sizing || 'md'}}">
                       <div class="dialog-content" ng-transclude></div>
                    </div>
                </div>
            `;
        }
    };
} 